import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromModifiersArray'
})
export class FromModifiersArrayPipe implements PipeTransform {
  transform(collection: Array<any>): string {    
    return collection.map(x => x.modifier.name.trim()).join(', ');
  }
}
